import { useQuery } from "@tanstack/react-query";
import { getBlogSection } from "../../api/apiBlogSection";

export function useGetBlogSection() {
    const { isLoading, data, error, refetch } = useQuery({
        queryKey: ["blog-section"],
        queryFn: getBlogSection,
        retry: false,
    });

    const sectionData = data?.data || null;

    return { isLoading, error, sectionData, refetch };
}
